import { Reducer, AnyAction } from "redux";
import {
  GET_USER_FOLDERS_REQUEST,
  GET_USER_FOLDERS_SUCCESS,
  GET_USER_FOLDERS_FAIL,
  GET_ONE_USER_FOLDER_REQUEST,
  GET_ONE_USER_FOLDER_SUCCESS,
  GET_ONE_USER_FOLDER_FAIL,
  CREATE_USER_FOLDER_REQUEST,
  CREATE_USER_FOLDER_SUCCESS,
  CREATE_USER_FOLDER_FAIL,
  UPDATE_USER_FOLDER_REQUEST,
  UPDATE_USER_FOLDER_SUCCESS,
  UPDATE_USER_FOLDER_FAIL,
  DELETE_USER_FOLDER_REQUEST,
  DELETE_USER_FOLDER_SUCCESS,
  DELETE_USER_FOLDER_FAIL,
  ATTACH_PRODUCT_REQUEST,
  ATTACH_PRODUCT_SUCCESS,
  ATTACH_PRODUCT_FAIL,
  DETACH_PRODUCT_REQUEST,
  DETACH_PRODUCT_SUCCESS,
  DETACH_PRODUCT_FAIL,
} from "../actions/user-folders-actions/types";

const init_state = {
  folders: [],
  oneFolder: null,
  isLoading: false,
  error: null,
  msg: null,
};

const userFoldersReducer: Reducer<any, AnyAction> = (
  state = init_state,
  action
) => {
  switch (action.type) {
    case GET_USER_FOLDERS_REQUEST:
    case GET_ONE_USER_FOLDER_REQUEST:
    case CREATE_USER_FOLDER_REQUEST:
    case UPDATE_USER_FOLDER_REQUEST:
    case DELETE_USER_FOLDER_REQUEST:
    case ATTACH_PRODUCT_REQUEST:
    case DETACH_PRODUCT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case GET_USER_FOLDERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        folders: action.payload,
      };

    case GET_ONE_USER_FOLDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        oneFolder: action.payload,
      };

    case CREATE_USER_FOLDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    case UPDATE_USER_FOLDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    case DELETE_USER_FOLDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        folders: state.folders.filter((f: any) => f.id !== action.payload),
      };

    case ATTACH_PRODUCT_SUCCESS:
    case DETACH_PRODUCT_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    case GET_USER_FOLDERS_FAIL:
    case GET_ONE_USER_FOLDER_FAIL:
    case CREATE_USER_FOLDER_FAIL:
    case UPDATE_USER_FOLDER_FAIL:
    case DELETE_USER_FOLDER_FAIL:
    case ATTACH_PRODUCT_FAIL:
    case DETACH_PRODUCT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default userFoldersReducer;
